import { styled } from '@mui/material/styles';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ErrorComponent } from '../Error/Error';
import { ForbiddenImage } from '../Error/pictures/Forbidden';

const StyledContainerError = styled(ErrorComponent)`
  height: 100% !important;
`;

export const AccessForbiddenPage = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StyledContainerError
      title={t('Forbidden')}
      subtitle={t('You came to the wrong space. You shall not pass!')}
      PictureComponent={ForbiddenImage}
      data-test="access-forbidden"
      actions={[
        {
          children: t('Take me home please'),
          color: 'secondary',
          'data-test': 'return-home',
          onClick: () => navigate(-1),
          variant: 'contained',
        },
      ]}
    />
  );
};
